
import {FC} from 'react'
import {Languages} from './Languages'
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../app/core/store/store.ts";
import {useIntl} from "react-intl";
import {logout} from "../../../../app/core/store/slices/sessionSlice.ts";
import { useNavigate } from 'react-router-dom';
import ERoutes from '../../../../app/core/enums/ERoutes.ts';
import logoutRequest from '../../../../app/core/api/requests/auth/logoutRequest.ts';

const HeaderUserMenu: FC = () => {
  const userMe = useSelector((state: RootState) => state.userMe)

  const dispatch = useDispatch()
  const navigate = useNavigate();
  const intl = useIntl()

  const signOut = async () => {
    try {
      await logoutRequest(dispatch, {closeAllSessions:true})
    } catch (e) {
      console.error('Logout request failed', e)
    } finally {
      dispatch(logout())
      navigate(ERoutes.AUTH, { replace: true });
    }
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={userMe?.profileImage} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {userMe?.user?.name} {userMe?.user?.lastName}
            </div>
            <span className='fw-bold text-muted fs-7'>
              {userMe?.user?.email}
            </span>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <Languages />

      <div className='menu-item px-5'>
        <span onClick={signOut} className='menu-link px-5'>
          {intl.formatMessage({ id: 'COMMON.SIGN_OUT' })}
        </span>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
